<nav ngxNavbarDynamicExpand class="navbar navbar-dark fixed-top bg-dark navbar-expand-md " #nav>
  <div class="container-fluid ">

    <a routerLink="/home" class="navbar-brand" style="min-width: 200px">
      <img class="h-100" src="./assets/images/logo.svg" alt="hello one enterprise">
    </a>


    <button class="navbar-toggler" type="button" (click)="collapse.toggle()" aria-label="Toggle navigation">
      <i class="fa fa-bars"></i>
    </button>

    <ngx-navbar-collapse #collapse="ngxNavbarCollapse">


      <div class="navbar-nav  mx-auto d-none d-md-block navbar-text text-white fw-light h5">
        <ng-container *ngIf="breadcrumbs.length > 0">
          <div class="d-inline-block" *ngFor="let breadcrumb of breadcrumbs; let first = first">
            <i *ngIf="!first" class="fas fa-level-up-alt fa-rotate-90 fa-xs mx-2 align-middle"></i>
            <ng-container *ngIf="breadcrumb.route; else nonLink">
              <a class="link-primary text-decoration-none" [routerLink]="breadcrumb.route">
                <ng-container *ngTemplateOutlet="text"></ng-container>
              </a>
            </ng-container>
            <ng-template #nonLink>
              <ng-container *ngTemplateOutlet="text"></ng-container>
            </ng-template>
            <ng-template #text>
              <span class="small">{{ breadcrumb.translate ? (breadcrumb.label | translate) : breadcrumb.label }}</span>
            </ng-template>
          </div>
          <div *ngIf="breadcrumbs.length > 1" class="d-inline-block ps-4">
            <i class="fas fa-long-arrow-alt-left fa-xs me-1"></i><button type="button" (click)="location.back()" class="link-primary bg-transparent border-0 small">{{ 'shared.misc.back_btn' | translate }}</button>
          </div>
        </ng-container>
        <ng-container *ngIf="breadcrumbs.length <= 0">
          {{ title }}
        </ng-container>
      </div>

      <div class="col">
        <app-content-header></app-content-header>
      </div>

    </ngx-navbar-collapse>

  </div>
</nav>

<div id="header-height" [style.height.px]="nav.offsetHeight">

</div>
